import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { InvitePeopleModalProps } from './src/ui/types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyComponent = lazyForPaint(
	() => import(/* webpackChunkName: "async-invite-people-modal" */ './src/ui/index.tsx'),
	{ ssr: false },
);

export const AsyncCoreInvitesDialogComponent = (props: InvitePeopleModalProps) => (
	<JSErrorBoundary
		id="async-invite-people-modal"
		packageName="jira-invite-people-modal"
		teamName="groot-growth"
	>
		<Placeholder name="jira-invite-people-modal" fallback={null}>
			<LazyComponent {...props} />
		</Placeholder>
	</JSErrorBoundary>
);

export default AsyncCoreInvitesDialogComponent;
